var sw = require('js/lib/sw');
var $ = require('js/sw-jquery/sw-jquery');

module.exports = function ($fragment) {
  $fragment.swFindWithSelf('[data-sw-model-material-configurator-model-dimensions]').each(function () {
    var el = this;
    var $this = $(this);
    var modelId = $(this).attr('data-sw-model-material-configurator-model-dimensions');
    var template = $this.find('[data-sw-model-material-configurator-model-dimensions-template]').get(0);
    var isMobile = $this.parent().attr('data-sw-model-material-configurator-model-dimensions-mobile');

    require(
      [
        'vue',
        'vuex',
        'js/store'
      ], function (vue, vuex, vuexStore) {
        /**
         * Vuex Store Module to provide actions and mutations for this component
         */
        vuexStore.registerModule('modelDimensionsComponent', {
          state: sw.data.vuexStoreState || {}, // add defaults here
          namespaced: true,
          mutations: {
            updateModelDimensions: function (state, payload) {
              state[payload.modelId].isPollingForModelDimensions = payload.isPollingForModelDimensions;
              state[payload.modelId].modelDimensions = payload.modelDimensions;
              state[payload.modelId].pricingDimensions = payload.pricingDimensions;
            },
            updateScale: function (state, payload) {
              state[payload.modelId].scale = payload.scale;
            },
            updateShowMoreDimensions: function (state, payload) {
              if (isMobile) {
                state[payload.modelId].showMoreDimensions = !state[payload.modelId].showMoreDimensions;
              }
            }
          },
          actions: {
            modelDimensionsPolling: function (context, payload) {
              context.commit('updateModelDimensions', payload);
            },
            updateScale: function (context, payload) {
              context.commit('updateScale', payload);
            },
            updateShowMoreDimensions: function (context, payload) {
              if (isMobile) {
                context.commit('updateShowMoreDimensions', payload);
              }
            }
          }
        });

        /**
         * Instantiate Vue root instance
         */
        new vue({
          el: el,
          data: {
            modelId: modelId
          },
          template: template,
          created: function () {
            if (this.isPollingForModelDimensions) {
              this.pollForModelDimensions();
            }
            /**
             * In order to get selectric to work with Vue, we render a string template
             * separately, then pass it to the Vue constructor to avoid Vue template
             * issues when Selectric manipulates the DOM.
             */
            this.$nextTick(function () {
              var _this = this;
              var $el = $(this.$el);
              sw.trigger('sw-fragment-loaded', $el);
              // Listen to changes in the selectric dropdown and pass it to the the Vue object method
              $el.on('selectric-change', function (e, el) {
                  _this.setScale(el.value);
              });
            });
          },
          store: vuexStore,
          computed: vuex.mapState({
            modelFileId: function(state) {
              return state[this.modelId].modelFileId;
            },
            isPollingForModelDimensions: function (state) {
              return state[this.modelId].isPollingForModelDimensions;
            },
            modelVolumeLabel: function(state) {
                switch (state[this.modelId].scale) {
                    case '1':
                        return 'inch<sup>3</sup>';
                    default:
                        return 'cm<sup>3</sup>';
                }
            },
            modelMaterialVolume: function (state) {
                switch (state[this.modelId].scale) {
                    case '1':
                        return state[this.modelId].pricingDimensions.materialVolumeInch;
                    default:
                        return state[this.modelId].pricingDimensions.materialVolumeCm;
                }
            },
            modelMachineVolume: function (state) {
                switch (state[this.modelId].scale) {
                    case '1':
                        return state[this.modelId].pricingDimensions.machineVolumeInch;
                    default:
                        return state[this.modelId].pricingDimensions.machineVolumeCm;
                }
            },
            modelSupportVolume: function (state) {
                switch (state[this.modelId].scale) {
                    case '1':
                        return state[this.modelId].pricingDimensions.supportVolumeInch;
                    default:
                        return state[this.modelId].pricingDimensions.supportVolumeCm;
                }
            },
            modelPartCountDimension: function (state) {
                if (!state[this.modelId].pricingDimensions) {
                   return 1;
                }
                return state[this.modelId].pricingDimensions.partCount;
            },
            modelPartsBoundsVolume: function (state) {
                if (state[this.modelId].scale === '1') {
                    return state[this.modelId].pricingDimensions.partsBoundsVolumeInch;
                }
                return state[this.modelId].pricingDimensions.partsBoundsVolumeCm;
            },
            modelXDimensions: function (state) {
              if (!state[this.modelId].modelDimensions) {
                return;
              }
              switch (state[this.modelId].scale) {
                case '1':
                  return state[this.modelId].modelDimensions.widthInch;
                default:
                  return state[this.modelId].modelDimensions.widthMm;
              }
            },
            modelYDimensions: function (state) {
              if (!state[this.modelId].modelDimensions) {
                return;
              }
              switch (state[this.modelId].scale) {
                case '1':
                  return state[this.modelId].modelDimensions.heightInch;
                default:
                  return state[this.modelId].modelDimensions.heightMm;
              }
            },
            modelZDimensions: function (state) {
              if (!state[this.modelId].modelDimensions) {
                return;
              }
              switch (state[this.modelId].scale) {
                case '1':
                  return state[this.modelId].modelDimensions.depthInch;
                default:
                  return state[this.modelId].modelDimensions.depthMm;
              }
            },
            showMaterialPrices: function (state) {
              return state[this.modelId].showMaterialPrices;
            },
            showMoreDimensions: function(state) {
              return state[this.modelId].showMoreDimensions || false;
            }
          }),
          methods: {
            pollForModelDimensions: function () {
              var params = {
                'modelFileId': this.modelFileId
              };
              var self = this;
              sw.polling(
                '/model/material-configurator/model-dimensions-polling',
                function (data) {
                  vuexStore.dispatch('modelDimensionsComponent/modelDimensionsPolling', {
                    isPollingForModelDimensions: data.isPollingForModelDimensions,
                    modelDimensions: data.modelDimensions,
                    pricingDimensions: data.pricingDimensions,
                    modelId: self.modelId
                  });
                },
                10000,
                params
              );
            },
            setScale: function setScale(scale) {
              vuexStore.dispatch('modelDimensionsComponent/updateScale', {
                scale: scale,
                modelId: this.modelId
              });
            },
            setShowMoreDimensions: function() {
              vuexStore.dispatch('modelDimensionsComponent/updateShowMoreDimensions', {
                modelId: this.modelId
              });
            }
          }
        });
      }
    );
  });
};
